import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '../hooks/useAuthencation';
interface UnAuthenRouteProps {
  children: React.ReactNode;
}

const UnAuthenRoute = ({ children }: UnAuthenRouteProps) => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default UnAuthenRoute;
